import Fingerprint2 from 'fingerprintjs2';

export const  calculateFingerPrint =  (callback) => {
    let fingerprintOptions = {
        excludes: {
            indexedDb: true,
            openDatabase: true,
            adBlock: true,
            fontsFlash: true,
            fonts: true,
            plugins: true,
            enumerateDevices : true
        }
    };
     Fingerprint2.get(fingerprintOptions, (components) => {
        let values = components.map(function (component) {
            return component.value
        });
        callback(Fingerprint2.x64hash128(values.join(''), 31));
    });
};
